import { useEffect, useState } from 'react'

export function getParamsStr(obj, persistParams = []) {
  const existingParams = new URLSearchParams(window.location.search)
  const params = new URLSearchParams()
  Object.entries(obj).forEach(([key, value]) => {
    if (value) {
      if (Array.isArray(value)) value = value.join(',')
      if (value) params.set(key, value)
      else params.delete(key)
    } else {
      params.delete(key)
    }
  })
  persistParams.forEach((key) => {
    if (existingParams.has(key)) params.set(key, existingParams.get(key))
  })

  return params.toString().replace(/%2C/g, ',')
}

export function useSetUrlParams(obj, persistParams = []) {
  const [urlParamsStr, setUrlParamsStr] = useState(getParamsStr(obj, persistParams))

  useEffect(() => {
    const newUrlParamsStr = getParamsStr(obj, persistParams)
    if (newUrlParamsStr !== urlParamsStr) {
      window.history.replaceState({}, '', `${window.location.pathname}${newUrlParamsStr ? `?${newUrlParamsStr}` : ''}`)
      setUrlParamsStr(newUrlParamsStr)
    }
  }, [obj, persistParams])

  return urlParamsStr
}

export function parseUrlParams(ignoreParams = []) {
  const urlParams = new URLSearchParams(window.location.search)
  ignoreParams.forEach((key) => urlParams.delete(key))
  const obj = {}
  for (const [key, value] of urlParams) {
    if (value.includes(',') || value.match(/^\d+$/)) {
      obj[key] = value.split(',').map((v) => parseInt(v))
    } else {
      obj[key] = value
    }
  }
  return obj
}
